<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { navigate } from "$lib/router.svelte";
  import Link from "$lib/components/Link.svelte";

  let name = $state(""); let email = $state(""); let password = $state("");
  let error = $state<string | null>(null);
  let loading = $state(false);

  // Capturar código de convite da URL
  const inviteCode = new URLSearchParams(window.location.search).get("invite") ?? "";

  async function submit(e: Event) {
    e.preventDefault();
    error = null; loading = true;
    try {
      await auth.register(email, password, name, inviteCode || undefined);
      navigate("/welcome");
    } catch (err: any) {
      error = err.message || "Erro ao cadastrar";
    } finally { loading = false; }
  }
</script>

<div class="min-h-screen flex items-center justify-center px-4">
  <form onsubmit={submit} class="card w-full max-w-md space-y-4">
    <h1 class="text-2xl font-bold text-brand">Criar conta TáKite</h1>
    {#if inviteCode}
      <div class="flex items-center gap-2 text-sm rounded-lg px-3 py-2" style="background: color-mix(in srgb, var(--brand) 10%, transparent); color: var(--brand)">
        🎁 Você foi convidado! Aceitar dará +15 dias grátis para você e quem te convidou.
      </div>
    {/if}
    {#if error}<div class="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-2">{error}</div>{/if}
    <div><label class="label" for="n">Nome</label><input id="n" class="input" bind:value={name} required /></div>
    <div><label class="label" for="e">E-mail</label><input id="e" type="email" class="input" bind:value={email} required /></div>
    <div><label class="label" for="p">Senha (mín. 12)</label><input id="p" type="password" class="input" bind:value={password} required minlength="12" /></div>
    <button class="btn-primary w-full" disabled={loading}>{loading ? "Criando…" : "Criar conta"}</button>
    <p class="text-sm text-slate-600 text-center">Já tem conta? <Link to="/login" class="text-brand font-medium">Entrar</Link></p>
  </form>
</div>
